import React from 'react';
import { InstagramIcon, PhoneIcon } from 'lucide-react';
import { LOGO_URL } from '../data/copy';
import { trackLead } from '../utils/metaPixel';
export function Footer() {
  return <footer className="w-full border-t-2 border-bone/10 bg-abyss px-4 py-9 pb-28 sm:px-8 sm:py-12" data-id="element-39" data-mp="32o4b2ak1486j">
      <div className="mx-auto flex max-w-6xl flex-col gap-5 sm:flex-row sm:items-center sm:justify-between" data-id="element-40" data-mp="36p6buvtlgsam">
        <div className="flex items-center gap-2.5" data-id="element-41" data-mp="3ueiltxwqx4dz">
          <img src={LOGO_URL} alt="Charly Baits" className="h-10 w-10 rounded-full object-cover object-left ring-1 ring-chartreuse/40" data-id="element-42" data-mp="3uftpzyu3se5m" />
          <span className="font-display text-xl uppercase tracking-wide text-bone" data-id="element-43" data-mp="3ldu4ouc22nwv">
            Charly Baits
          </span>
        </div>
        <p className="max-w-md font-body text-sm leading-relaxed text-ash" data-id="element-44" data-mp="29z6t68jqcdeb">
          Señuelos de plástico suave moldeados a mano en México. Para el
          pescador que ya se hartó de contar historias de la que se fue.
        </p>
        <div className="flex items-center gap-5 font-cond text-base uppercase tracking-wide text-bone/80" data-id="element-45" data-mp="3l8qxu8j60rtk">
          <a href="#pack" onClick={() => trackLead('footer-whatsapp')} className="flex items-center gap-2 transition-colors hover:text-chartreuse" data-id="element-46" data-mp="3gbimorwfpo1t">
            <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-47" data-mp="3q7lm3pzwj8l2" />
            WhatsApp
          </a>
          <a href="#pack" className="flex items-center gap-2 transition-colors hover:text-chartreuse" data-id="element-48" data-mp="81yvyfozns2e">
            <InstagramIcon className="h-4 w-4" aria-hidden="true" data-id="element-49" data-mp="31uqrltj6jrh" />
            Instagram
          </a>
        </div>
      </div>
      <p className="mx-auto mt-8 max-w-6xl font-body text-xs text-ash/70" data-id="element-50" data-mp="cu0fmmohkl2g">
        © {new Date().getFullYear()} Charly Baits. Todos los derechos
        reservados.
      </p>
    </footer>;
}